module.exports = __webpack_public_path__ + "static/media/offer-expired.7fc3083b.png";